export default "__VITE_ASSET__Bpn7zKY9__"